export const parseFileNameFromResponse = (contentDisposition: string) => {
  return contentDisposition ? contentDisposition.split(';')[1].split('filename=')[1]?.replace(/['"]+/g, '') : null;
};
